var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReject = function SvgReject(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.242 1.757A5.98 5.98 0 0 0 6 0a6 6 0 1 0 4.242 1.757M2 5.891c0-1.04.405-2.016 1.139-2.75A3.87 3.87 0 0 1 5.89 2c.761 0 1.487.219 2.11.623L2.623 8A3.86 3.86 0 0 1 2 5.89m6.86 2.97A3.87 3.87 0 0 1 6.11 10c-.761 0-1.487-.22-2.11-.622L9.377 4c.404.623.623 1.349.623 2.109 0 1.04-.405 2.016-1.14 2.75"
  })));
};
export default SvgReject;